// extracted by mini-css-extract-plugin
module.exports = {"group":"group--3RLE_","error":"error--32Qy6","group-error":"group-error--9QkDv","sm":"sm--1hCUT","md":"md--5zmCr","lg":"lg--2Weut"};